var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.234 6.163h2.887v13.215c0 .172.14.312.313.312h2.343c.172 0 .313-.14.313-.312V6.163h2.894c.262 0 .407-.3.246-.504L14.855.119a.313.313 0 00-.492 0L9.988 5.656a.314.314 0 00.246.508zm18.672 12.043h-2.343a.313.313 0 00-.313.312v6.016H2.969v-6.016a.313.313 0 00-.313-.312H.312a.313.313 0 00-.312.312v7.735c0 .691.559 1.25 1.25 1.25h26.719c.691 0 1.25-.559 1.25-1.25v-7.735a.314.314 0 00-.313-.312z",
    fill: "#1A1617",
    fillOpacity: 0.92
  })));
}
export default __webpack_public_path__ + "img/d866deb3d44a73820a1b3da9a8b1213c.svg";
export { SvgFileUpload as ReactComponent };